import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpUpdateProjectBudget, HttpUpdateProjectBudgetOptions} from '../http/budget.http'
import {ProjectBudgets} from '../types'

export const useUpdateProjectBudget = (
    options?: UseMutationOptions<ProjectBudgets, unknown, HttpUpdateProjectBudgetOptions>
) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: httpUpdateProjectBudget,
        ...options,
        onSuccess: (data, variables, context) => {
            queryClient.setQueryData([QUERY_KEYS.PROJECT_BUDGETS], (oldData: ProjectBudgets[]) =>
                oldData.map(item => (item.id == variables.urlParams.id ? data : item))
            )
            options?.onSuccess?.(data, variables, context)
        }
    })
}
